import React, { useEffect, useState } from 'react';
import './GoogleTranslate.css';

const GoogleTranslate = () => {
  const [activeLang, setActiveLang] = useState(() => {
    return localStorage.getItem('activeLang') || 'en';
  });

  useEffect(() => {
    document.documentElement.lang = activeLang;
  }, [activeLang]);

  useEffect(() => {
    const scriptId = 'google-translate-script';

    const waitForElement = (selector, callback, interval = 100, timeout = 5000) => {
      const startTime = Date.now();
      const timer = setInterval(() => {
        const element = document.querySelector(selector);
        if (element) {
          clearInterval(timer);
          callback(element);
        } else if (Date.now() - startTime > timeout) {
          clearInterval(timer);
          //console.warn(`Timeout: Element "${selector}" not found.`);
        }
      }, interval);
    };

    const applyTranslation = (lang) => {
      const select = document.querySelector('.goog-te-combo');
      if (!select) return;
      select.value = lang;
      select.dispatchEvent(new Event('change'));
    };

    const initGoogleTranslate = () => {
      if (window.google && window.google.translate) {
        new window.google.translate.TranslateElement(
          { pageLanguage: 'en', autoDisplay: false },
          'google_translate_element'
        );

        waitForElement('.goog-te-combo', () => {
          applyTranslation(activeLang);
        });
      }
    };

    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      document.body.appendChild(script);
      window.googleTranslateElementInit = initGoogleTranslate;
    } else {
      initGoogleTranslate();
    }
  }, [activeLang]);

  const handleToggle = () => {
    const newLang = activeLang === 'en' ? 'es' : 'en';
    setActiveLang(newLang);
    localStorage.setItem('activeLang', newLang);

    const select = document.querySelector('.goog-te-combo');
    if (select) {
      select.value = newLang;
      select.dispatchEvent(new Event('change'));
    }
  };

  return (
    <div className="toggle-container">
      <label className="toggle-switch">
        <input
          type="checkbox"
          checked={activeLang === 'es'}
          onChange={handleToggle}
        />
        <span className="toggle-icons">
          <span className={activeLang === 'en' ? 'lang-en active' : 'lang-en'}>English</span>
          <span className={activeLang === 'es' ? 'lang-es active' : 'lang-es'}>Spanish</span>
        </span>
      </label>

      <div id="google_translate_element" style={{ display: 'none' }}></div>
    </div>
  );
};

export default GoogleTranslate;
